<div class="table">
    <div class="row table-header">
        <!-- Checkbox Column -->
        @if (withCheckboxAll) {
            <div class="checkbox-column">
                <mat-checkbox
                    color="primary"
                    [formControl]="allCheckedControl"
                    (click)="$event.stopPropagation()"
                    [disabled]="expandFilterResultControl.value !== null && expandFilterResultControl.value">
                </mat-checkbox>
            </div>
        }
        <!-- Dynamic Columns -->
        <div
            class="dynamic-columns-size"
            [ngStyle]="{
                'padding-left': withCheckbox && !withCheckboxAll ? '25px' : '0px',
            }"
            [ngClass]="{
                'dynamic-columns-size-with-actions': withActions && !withActionsIcon,
                'dynamic-columns-size-with-actions-icon': withActions && withActionsIcon && !withCheckbox,
                'dynamic-columns-size-with-actions-icon-and-checkbox': withActions && withActionsIcon && withCheckbox,
                'dynamic-columns-size-with-delete-icon-and-checkbox': withDeleteIcon && withCheckbox,
            }">
            @for (col of tableColumns; track col) {
                <div
                    class="col"
                    (click)="columnSortClicked(col)"
                    [ngClass]="{ 'sortable-column': col.isSortable }"
                    [ngStyle]="{
                        width:
                            col.widthType === WidthTypeEnum.Pixel
                                ? col.width.toString() + 'px'
                                : 'calc((100% - ' + columnsTotalStaticPixels.toString() + 'px) * ( ' + col.width.toString() + '/ 100 )',
                    }"
                    [title]="col.descriptionLabelPath | labelsProvider">
                    {{ col.labelPath | labelsProvider }}
                    @if (col.isSortable) {
                        <img
                            src="assets/images/common/sort-icon.svg"
                            [ngClass]="{
                                'sort-inactive': !sortedColumn() || (sortedColumn() && sortedColumn()?.column?.sortKey !== col.sortKey),
                                'sort-asc': sortedColumn() && sortedColumn()?.column?.sortKey === col.sortKey && !sortedColumn()?.isDesc,
                            }" />
                    }
                </div>
            }
        </div>
        <!-- Actions Column -->
        @if (withActions && !withActionsIcon) {
            <div class="actions-column">
                {{ "tableActionsAndFilters.actionsColumn" | labelsProvider }}
            </div>
        }
    </div>

    <!-- Table Body -->
    <div class="table-body" [ngClass]="{ 'table-body-with-pagination': withPagination }">
        @if (withCheckboxAll && checkedRowsIds.size > 0) {
            <div class="row custom-row">
                @if (withExpandFilters) {
                    <div class="rows-selection-container">
                        @if (!expandFilterResultControl.value) {
                            <div>
                                {{ checkedRowsIds.size }}
                                {{ "tableActionsAndFilters.selectedRowsText" | labelsProvider }}
                            </div>
                        } @else {
                            <div>
                                {{ pageInfo.totalItems }}
                                {{ "tableActionsAndFilters.selectedRowsText" | labelsProvider }}
                            </div>
                        }
                        <div>
                            {{ "tableActionsAndFilters.expandResultsText" | labelsProvider }}
                        </div>
                        <mat-checkbox
                            color="primary"
                            [checked]="expandFilterResultControl.value"
                            (change)="expandFilterResultsOnChange()"
                            [matTooltip]="'common.violationsBulkTooltip' | labelsProvider"
                            matTooltipPosition="below"
                            matTooltipClass="tooltip-container">
                        </mat-checkbox>
                    </div>
                } @else {
                    <div class="rows-selection-container">
                        <div>
                            {{ checkedRowsIds.size }}
                            {{ "tableActionsAndFilters.selectedRowsText" | labelsProvider }}
                        </div>
                    </div>
                }
                <app-actions-menu-select
                    class="multi-actions"
                    [actions]="(checkedRowsSupportedActions$ | async) ?? []"
                    [forceUsingSelectOptions]="true"
                    (actionOnClick)="multiCheckOnClick.emit($event)">
                </app-actions-menu-select>
            </div>
        }
        <!-- Table Rows Container -->
        <div
            class="table-body-rows-container"
            [ngClass]="{
                'table-body-scrollable': isScrollable,
                'multi-action-visible': withCheckboxAll && checkedRowsIds.size > 0,
            }">
            @for (tableRow of tableRows | async; track tableRow) {
            <div [matTooltip]="getTooltipText(tableRow)" matTooltipPosition="above">
                <app-table-row
                    [behaviorSubjectRow]="tableRow"
                    [rowColumns]="tableColumns"
                    (rowOnClick)="onRowClick(tableRow)" 
                    (rowActionOnClick)="onRowActionClick($event)"
                    (toggleOnClick)="onToggleClick($event)" 
                    (rowOnChangeState)="onRowChangeState($event)"
                    (deleteRowOnClick)="onDeleteIconClick($event)" 
                    (checkboxOnClick)="onCheckboxClick($event)"
                    [withActions]="withActions" 
                    [withActionsIcon]="withActionsIcon" 
                    [withCheckbox]="withCheckbox"
                    [withDeleteIcon]="withDeleteIcon" 
                    [dropDownOptions]="dropDownOptions"
                    (dropdownOnSelection)="onOptionSelected($event)">
                </app-table-row>
            </div>
            }
        </div>
        <!-- Loading Spinner -->
        @if (isLoading() && !((tableRows | async)?.length === 0)) {
            <div class="table-row-spinner">
                <div class="small-spinner">
                    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
                </div>
            </div>
        }
    </div>
    <!-- Pagination -->
    @if (!noData() && withPagination) {
        <div class="table-pagination">
            <div class="items-data">
                <div>
                    {{ pageInfo.maxSize * (pageInfo.number - 1) + 1 }}-{{ pageInfo.maxSize * (pageInfo.number - 1) + pageInfo.currSize }} of
                    {{ pageInfo.totalItems }}
                </div>
            </div>
            <div class="navigation">
                @if (pageInfo.number > 1) {
                    <img src="assets/images/arrows/pagination-arrow.svg" (click)="prevPageClicked()" class="left-arrow" />
                }
                <div class="total-amount">{{ pageInfo.number }} of {{ pageInfo.totalPages }}</div>
                @if (pageInfo.number < pageInfo.totalPages) {
                    <img src="assets/images/arrows/pagination-arrow.svg" (click)="nextPageClicked()" class="right-arrow" />
                }
            </div>
        </div>
    }

    <!-- No Data -->
    @if (noData() && isLoading() === false) {
        <div>
            <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon" [isAbsolutePosition]="false" />
        </div>
    }

    <!-- Loading Spinner -->
    @if (isLoading() && (tableRows | async)?.length === 0) {
        <div class="table-spinner">
            <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
        </div>
    }
</div>
